// extracted by mini-css-extract-plugin
module.exports = {"content":"decision_popover-module__content--3CSA-","chips":"decision_popover-module__chips--KuMiM","chip":"decision_popover-module__chip--1SduJ"};